import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

import './styles.scss';
import QuestionsOverview from '../QuestionsOverview';
import CharmBracelet from '../CharmBracelet';
import cn from 'classnames';

/**
 * The menu with handler and content for mobile version.
 * */
const QuestionList = ({
  showUpdatedCharmBracelet,
  onClose,
  title,
  ...props
}) => {
  const Navigation = showUpdatedCharmBracelet
    ? CharmBracelet
    : QuestionsOverview;

  return (
    <div className="question-list-content">
      <div className="container">
        <div className="return-button" onClick={onClose}>
          <Icon id="nav-arrow" width="7" height="13" />
          <div className="return-button-text">Back to Question</div>
        </div>
      </div>
      <div className={cn('container', 'title')}>{title}</div>
      <Navigation
        key="QuestionsOverview-mobile"
        isMobile
        closeMenuContent={onClose}
        {...props}
      />
    </div>
  );
};

QuestionList.displayName = 'QuestionList';

export default QuestionList;
